// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"57456a6d","453":"ea7d2aee","455":"47e8f1c3","977":"86c09e37"}[chunkId] + ".chunk.js";
};